/* eslint-disable react-hooks/rules-of-hooks */
import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { UploadedFile } from '@frontend/data-access';
import { NotificationInstance } from 'antd/lib/notification/interface';
import { Translate } from 'next-translate';
import useTranslation from 'next-translate/useTranslation';

import styles from './documents.module.less';

/* eslint-disable-next-line */
export interface DocumentsProps {}

/**
 * Handle open document
 * @param document - Uploaded file
 * @param notification - Notification instance
 * @param t - Translate 'common'
 */
export function handleOpenDocument(
  document: UploadedFile,
  notification: NotificationInstance,
  t: Translate
) {
  switch (document?.state) {
    case 'INFECTED':
      notification.open({
        message: t('virus_detected'),
        icon: (
          <span className="text-red-600">
            <CloseCircleOutlined />
          </span>
        ),
      });
      break;
    case 'PROCESSING':
      notification.open({
        message: t('virus_scanning'),
        icon: (
          <span className="text-primary-600">
            <InfoCircleOutlined />
          </span>
        ),
      });
      break;
    case 'NOT_IN_MIME':
      notification.open({
        message: t('file_type_not_supported'),
        icon: (
          <span className="text-primary-600">
            <InfoCircleOutlined />
          </span>
        ),
      });
      break;
    default:
      window.open(document?.url);
      break;
  }
}

export function Documents(props: DocumentsProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['container']}>
      <h1>{t('welcome_documents')}</h1>
    </div>
  );
}
